import Image from "next/image";

function GutRules() {
  // Aquí puedes usar el valor de "categories" para mostrar contenido específico
  // relacionado con la ruta dinámica.

  return (
    <section className="container relative lg:mt-24 lg:pt-24 lg:pb-24 mt-24 pt-12 pb-24">
      <picture className="pointer-events-none absolute inset-x-0 -top-32 -z-10 block dark:hidden h-full">
        <Image
          src="/images/gradient.jpg"
          alt="gradient"
          className="h-full w-full"
          height={1000}
          width={2000}
        />
      </picture>
      <picture className="pointer-events-none absolute inset-x-0 -top-32 -z-20 hidden dark:block">
        <Image
          src="/images/gradient_dark.jpg"
          alt="gradient dark"
          className="h-full w-full"
          height={1000}
          width={2000}
        />
      </picture>
      <div>
        <header className="mx-auto mb-20 max-w-lg text-center font-display">
          <div className="mb-3 inline-flex flex-wrap items-center space-x-1 text-xs"></div>
          <h1 className=" text-jacarta-600  text-2xl dark:text-white sm:text-5xl ">
            PZL Rules
          </h1>
          <h3 className="text-jacarta-500 dark:text-jacarta-300">
            Learn how the PZL token will behave in possible scenarios over time.
          </h3>

          {/* <!-- Author --> */}
        </header>
        <article className="mb-12">
          <div className="article-content">
            <p>
              Owners of PZL Tokens must know certain rules about how PZL will
              respond to specific circumstances:
            </p>
            <ul>
              <li>
                Under what conditions will PuzzleHousing sell a property?
                <p className="mt-2">
                  PuzzleHousing will automatically sell a property if it
                  receives an offer that is 30% higher plus inflaction than its
                  purchase price.
                </p>
              </li>
              <li>
                Leverage Level and Puzzle-Housing Behavior:
                <p className="mt-2">
                  The maximum leverage level that Puzzle-Housing will support is
                  33%. Once 10 properties or multiples of 10 properties are
                  reached, Puzzle-Housing will calculate its leverage level, and
                  if it is below 33%, Puzzle-Housing will acquire properties
                  until reaching the maximum leverage limit.
                  <br />
                  hese properties will be subject to a vote, and users holding
                  PLZ will be able to vote on which properties to acquire.
                  Properties acquired through credit will be amortized normally
                  with the income they generate themselves plus 10% of all the
                  income from all other properties. This will gradually reduce
                  the leverage level. When Puzzle-Housing reaches the next
                  multiple of 10 properties, leverage will be recalculated to
                  decide whether to acquire more properties.
                </p>
                <p>
                  After 5 years of production, a vote will be proposed among the
                  owners of GUT tokens to extend this period. In the case of a
                  negative vote, the proceeds from sales will go directly
                  towards rewards in the form of dividends. In this case,
                  properties already acquired by PuzzleHousing will continue to
                  distribute dividends through the GUT token, but new properties
                  will be funded with a new token called GUTv2 that will start a
                  new 5-year cycle.
                </p>
              </li>
            </ul>
            <p className="mt-2">
              If Puzzle-Housing receives an offer 30% higher plus inflation than
              what was paid for the property, Puzzle-Housing will sell it. The
              proceeds from the sale will be used to finance the next property.
              Puzzle-Housing will act in this manner for 5 years, after which a
              vote will be held to continue acting in the same way or to
              distribute the proceeds from the sales as dividends to the PLZ
              holders.
            </p>

            <div>
              TLTR:
              <p>
                PuzzleHousing establishes rules for PZL Token holders in
                relation to PuzzleHousing and property sales. If PuzzleHousing
                receives an offer that is 30% higher plus inflaction than the
                purchase price, it will automatically sell a property. The
                capital from the sale will fund the next property.{" "}
              </p>
              <p>
                After 5 years, a vote will determine an extension, if negative,
                sales will be converted into dividends. If it is positive,
                Puzzle-Housing will continue its behavior for another 5 years.
              </p>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}

export default GutRules;
